<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İsim</label>
            <input type="text" v-model="value.Name" class="form-control" placeholder="İsim"/>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.IsHasValidityYear">Yenileme Süresi (Yıl) Var</b-form-checkbox>
        </div>
        <div class="col-12 mb-1" v-if="value.IsHasValidityYear">
            <label class="form-label">Yenileme Süresi (Yıl)</label>
            <input type="number" v-model="value.ValidityYear" class="form-control" placeholder="Yenileme Süresi (Yıl)"/>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.FileRequired">Dosya Gerekli</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>